export default (templates, options = {}) =>
  templates[options.template] || templates.default;
